export const LIKES_PAGE_SIZE = 24;
